<script lang="ts" setup>
  import type { TypeDividerComponent } from '~/types/contentful'

  defineProps<{
    data: TypeDividerComponent<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <CDivider
    :background-color="data.fields.base?.fields.backgroundColour"
    :color="data.fields.colour"
    :variant="data.fields.style"
    class="module-paddings-h"
  />
</template>
